<template>
  <div class="refound-item-wrap">
    <div class="order-top">
      <div>
        <span class="charge-at"
          >退款单号：{{ refundInfo.refund_order_no }}
        </span>
        <span class="order-no">交易单号：{{ refundInfo.order_no }}</span>
      </div>
      <span class="created-at">
        支付时间：{{
          moment(refundInfo.charge_at * 1000).format("YYYY-MM-DD HH:mm:ss")
        }}</span
      >
    </div>
    <div class="order-bottom">
      <div class="left-wrap">
        <div v-for="item in refundInfo.goods || []" :key="item.goods_id">
          <div class="course-item">
            <img
              class="cover"
              :src="
                handleImageUrl(item.goods_cover_url) + '?imageView2/0/w/340'
              "
              alt=""
            />
            <div class="course-info">
              <p class="title">
                {{ item.goods_title }}
              </p>
              <p class="course-id">ID：{{ item.course_id }}</p>
            </div>
            <button @click="showUseDetail(item)" class="primary-btn">
              使用详情
            </button>
          </div>
        </div>
      </div>
      <div class="right-wrap">
        <!-- 订单总价 -->
        <div class="total-price-wrap">
          <p class="total-price">{{ formatPrice(refundInfo.real_price) }}</p>
          <p class="channel">{{ payType[refundInfo.channel] || "-" }}</p>
        </div>
        <!-- 订单-操作 -->
        <div class="refund-info">
          <!-- 退款失败/退款完成-->
          <p class="tips" v-if="refundInfo.reply_result">
            {{ replyResult[refundInfo.reply_result] }}
          </p>
          <div class="refund-price-wrap">
            <p class="total-price">{{ formatPrice(refundInfo.refund_cash) }}</p>
            <p class="refund-tips">全额退款</p>
          </div>
          <button
            @click="showRefundDetail(refundInfo)"
            class="primary-btn show-detail"
          >
            查看详情
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import refundItem from "../mixins/refund-item";
export default {
  mixins: [refundItem],
};
</script>

<style lang="scss" scoped>
.refound-item-wrap {
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #efefef;
  margin-bottom: 16px;
  .order-top {
    border-radius: 12px 12px 0 0;
    background: $saas-bg-color;
    height: 50px;
    padding: 0 20px 0 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .charge-at {
      font-weight: 500;
      font-size: 12px;
      color: $saas-text-color;
      line-height: 17px;
      margin-right: 30px;
    }
    .order-no {
      font-weight: 400;
      font-size: 12px;
      color: #60625f;
      line-height: 17px;
    }
    .created-at {
      font-weight: 400;
      font-size: 12px;
      color: #747573;
      line-height: 17px;
    }
  }
  .order-bottom {
    padding: 0 20px 0 16px;
    display: flex;
    align-items: center;
    .left-wrap {
      flex: 1;
    }
    .right-wrap {
      width: 480px;
      display: flex;
      justify-content: space-between;
    }
    .refund-info {
      display: flex;
      align-items: center;
      .tips {
        font-weight: 400;
        font-size: 12px;
        color: $saas-text-color;
      }
    }
  }
  // 单个课
  .course-item {
    display: flex;
    border-bottom: 1px solid #efefef;
    padding: 16px 0;
    &:last-child {
      border-bottom: none;
    }
    .cover {
      width: 107px;
      height: 60px;
      margin-right: 12px;
      border-radius: 8px;
      object-fit: cover;
    }
    .course-info {
      width: 254px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-right: 50px;
    }
    .title {
      width: 100%;
      font-weight: 500;
      font-size: 12px;
      color: $saas-text-color;
      line-height: 17px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
    .course-id {
      font-size: 12px;
      color: #747573;
      line-height: 17px;
    }
  }

  .total-price-wrap {
    width: 100px;
    .total-price {
      font-weight: 400;
      font-size: 12px;
      color: $saas-text-color;
      line-height: 17px;
      text-align: center;
    }
    .channel {
      padding-top: 5px;
      font-size: 12px;
      color: #747573;
      line-height: 17px;
      text-align: center;
    }
  }
  .refund-price-wrap {
    width: 100px;
    margin-left: 25px;
    .total-price {
      font-weight: 500;
      font-size: 16px;
      color: $saas-text-color;
      line-height: 22px;
      text-align: center;
    }
    .refund-tips {
      padding-top: 5px;
      font-size: 12px;
      color: $saas-text-color;
      line-height: 17px;
      text-align: center;
    }
  }
  .channel,
  .refund-tips {
    padding-top: 5px;
    font-size: 12px;
    color: #747573;
    line-height: 17px;
    text-align: center;
  }

  // 状态
  .order-status {
    span {
      display: inline-block;
      width: 90px;
    }
    text-align: right;
  }
  .primary-btn {
    font-size: 12px;
    color: #00c89d;
    line-height: 17px;
    padding: 5px;
  }
  .cancel-btn {
    font-size: 12px;
    color: #515350;
    line-height: 17px;
    padding: 5px;
  }
  .show-detail {
    margin-left: 15px;
  }
}
</style>
